import angular from "angular"

//import "./table.component.css"
const templateUrl = require("ngtemplate-loader!html-loader!./table-paginacion-local.component.html")

TablePaginacionLocalComponent.$inject = ["DTOptionsBuilder", "$timeout"]
function TablePaginacionLocalComponent(DTOptionsBuilder, $timeout) {
  var vm = this
  vm.rows = []
  vm.totalRows = 4
  vm.selected = {}
  vm.selectedAll = false

  vm.toggleSelectedRow = function(row_id) {
    vm.selectedAll = vm.areChecked()
  }

  vm.toggleSelectAll = function() {
    for (var i = 0; i < vm.rows.length; i++) {
      vm.rows[i].isSelected = vm.selectedAll
    }
  }

  vm.areChecked = function() {
    var total = vm.rows.length
    var countSelected = 0
    var conjunction = true
    for (var i = 0; i < vm.rows.length; i++) {
      if (vm.rows[i].isSelected) {
        countSelected += 1
      }
      conjunction = conjunction && vm.rows[i].isSelected
    }

    return conjunction && total == countSelected
  }

  vm.getSelection = function(propertiesCallback) {
    var keys = Object.keys(vm.selected)
    var selected = []

    if (!propertiesCallback) {
      propertiesCallback = function(row) {
        return row.id
      }
    }

    for (var i = 0; i < vm.rows.length; i++) {
      if (vm.rows[i].isSelected) {
        selected.push(propertiesCallback(vm.rows[i]))
      }
    }
    return selected
  }

  vm.dtOptions = DTOptionsBuilder.newOptions()
    .withLanguage({
      sProcessing: "Procesando...",
      sLengthMenu: "Mostrar _MENU_ registros",
      sZeroRecords: "No se encontraron resultados",
      sEmptyTable: "No se encontraron resultados",
      sInfo: "_START_ a _END_ de _TOTAL_",
      sInfoEmpty: "",
      sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
      sInfoPostFix: "",
      sSearch: "",
      sUrl: "",
      sInfoThousands: ".",
      sLoadingRecords: "Cargando...",
      oPaginate: {
        sFirst: "|<",
        sLast: ">|",
        sNext: ">",
        sPrevious: "<"
      },
      oAria: {
        sSortAscending: ": Activar para ordenar la columna de manera ascendente",
        sSortDescending: ": Activar para ordenar la columna de manera descendente"
      }
    })
    .withPaginationType("simple")
    .withDisplayLength(vm.totalRows)
    .withOption("scrollY", "260px")
    .withOption("scrollX", "100%")
    .withDOM("ftrpi")

  vm.dtColumnDefs = []

  vm.dtInstance = {}

  vm.reloadTable = function() {
    vm.rowsPromise().then(function(data) {
      vm.rows = data
      $timeout(function() {
        vm.dtInstance.rerender()
      }, 0)
      console.log("rerender table")
      vm.selectedAll = false
    })
  }

  vm.$onChanges = function(data) {
    if (vm.reloadTable && vm.dtInstance.rerender) {
      if (data.reload || data.columns) {
        vm.reloadTable()
      }

      if (data.doDelete) {
        vm.deleteRows({ models: vm.getSelection() })
      }

      if (data.doEdit) {
        vm.editRows({
          models: vm.getSelection(function(row) {
            return row
          })
        })
      }
    }
  }

  vm.$onInit = function() {
    if (vm.maxRows) {
      vm.dtOptions["iDisplayLength"] = vm.maxRows
    }

    vm.reloadTable()
  }

  vm.openMenu = function($mdOpenMenu, ev) {
    $mdOpenMenu(ev)
  }
}

angular.module("appModule").component("tablePaginacionLocal", {
  templateUrl: templateUrl,
  bindings: {
    columns: "<",
    rowsPromise: "<",
    reload: "<",
    doDelete: "<",
    doEdit: "<",
    editRows: "&",
    deleteRows: "&",
    menuOptions: "<",
    maxRows: "<"
  },
  controller: TablePaginacionLocalComponent
})
